import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') != undefined ? localStorage.getItem('token') : undefined;

export default axios.create({
    // baseURL: window.location.href.includes('localhost') ? 'http://localhost:8081/wscontigo/public/' : 'http://localhost:8081/wscontigo/public/'
  });